import React, { useState } from 'react';

import OptimizeLayout3 from '@totem/components/services/optimize/v3/optimizeLayout3';
import TicketListContainer, {
  containerConfiguration as ticketContainerConfiguration,
} from '@totem/components/ticketing/listContainer/TicketListContainer';
import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import InputContainer from '@totem/components/ui_components/reportSettings/InputContainer';
import RecordCountBadge from '@totem/components/ui_components/widgets/RecordCountBadge';

const OptimizePage3 = () => {
  const [totalRecords, setTotalRecords] = useState<number>(0);

  return (
    <ContentLayout landingPageName="optimize">
      <InputContainer
        filterConfig={ticketContainerConfiguration}
        defaultPageSize={100}
        defaultSort={{
          field: 'createdAt',
          direction: 'descend',
        }}
        staticFilters={[
          {
            field: 'category',
            values: ['Optimize'],
          },
          {
            field: 'subCategory',
            values: ['Opportunity'],
          },
        ]}
        defaultFilters={[
          {
            field: 'status',
            values: ['OPEN', 'RESOLVED', 'CLOSED'],
          },
        ]}
        componentKey="services-optimize3"
      >
        <TicketListContainer onRecordTotalChanged={setTotalRecords}>
          <IBCard
            isCovered
            title="Opportunities"
            extra={<RecordCountBadge count={totalRecords} />}
          >
            <OptimizeLayout3 />
          </IBCard>
        </TicketListContainer>
      </InputContainer>
    </ContentLayout>
  );
};

export default OptimizePage3;
